import { IRaffleBlacklist } from '../../../interfaces';
import privateHttpClient from '../privateHttpClient';
import RaffleBlacklistMapper from '../mappers/RaffleBlacklistMapper';
import { urlHttpGov } from '../../urls';

class RaffleBlacklistService {
    private baseURL: string = `${urlHttpGov}/panel/raffle-blacklist`;

    async listBlacklist(cityId: number, signal: AbortSignal) {

        const { data } = await privateHttpClient.get(`${this.baseURL}/county/${cityId}`, { signal });

        return data.map((raffleBlacklist: any) => RaffleBlacklistMapper.toDomain(raffleBlacklist));
    }

    async getBlacklistById(id: number, signal: AbortSignal) {
        const { data } = await privateHttpClient.get(`${this.baseURL}/${id}`, { signal });

        return RaffleBlacklistMapper.toDomain(data);
    }

    async insertInBlacklist({countyId, cpfCnpj, name}: {countyId: number, cpfCnpj: string, name?: string}) {
        const { data } = await privateHttpClient.post(`${this.baseURL}/county/${countyId}`, { cpfCnpj, name });

        const domainCnpjBlacklist = RaffleBlacklistMapper.toDomain(data);

        return domainCnpjBlacklist;
    }

    async updateInBlacklist({id, cpfCnpj}: {id: number, cpfCnpj: IRaffleBlacklist}) {
        const persistenceCnpjBlacklist = RaffleBlacklistMapper.toPersistence(cpfCnpj);

        return privateHttpClient.put(`${this.baseURL}/${id}`, persistenceCnpjBlacklist);
    }

    async deleteInBlacklist(id: number) {
        return privateHttpClient.delete(`${this.baseURL}/${id}`);
    }


}

// eslint-disable-next-line import/no-anonymous-default-export
export default new RaffleBlacklistService();
